import axios from 'axios'
import {Message} from 'element-ui'
import store from '@/store'
import router from '@/router'
import {getToken} from '@/utils/auth'

let requestQueue = []
let lastRequest = {}
// axious instance create
const service = axios.create({
  baseURL: process.env.BASE_API, // api base_url
  // timeout: 5000 // Request timeout
})

let isPending = false

function serviceDecorator(config) {
  let promise
  // Return promises for requests stacks in queue
  if (isPending && config.url !== '/oauth/v2/token') {
    return new Promise(function (resolve, reject) {
      requestQueue.push({config, resolve, reject})
    })
  }
  // Return request for last request for repeat if needed
  return new Promise(async function (resolve, reject) {
    if (config.url !== '/oauth/v2/token') {
      lastRequest = ({config, resolve, reject})
    }
    try {
      const response = await service(config)
      resolve(response)
    } catch (error) {
      console.log(`Error in request: ${error}`)
      // throw new Error(error)
      reject(error)
    }
  })
}

// request interceptor
service.interceptors.request.use(config => {
  config.headers = {
    accept: 'application/json'
  }
  const token = store.getters.token || getToken()
  if (token) {
    // Set auth header before each request
    // config.headers['Authorization'] = `Bearer ${store.getters.token}`
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => {
  // Do something with request error
  console.log('error on request', error) // for debug
  return Promise.reject(error)
})

async function refreshToken() {
  return new Promise((resolve, reject) => {
    store.dispatch('RefreshToken').then(() => {
      resolve()
    }).catch(error => {
      Message.error('Ошибка авторизации, пожалуйста пройдите авторизацию')
      router.push({path: '/login'})
    })
  })
}

function resendPendingRequests() {
  requestQueue.forEach(async deferredRequest => {
    const config = deferredRequest.config
    const resolve = deferredRequest.resolve
    try {
      const response = await service(config)
      resolve(response)
    } catch (error) {
      console.log(`errResolve ${error}`)
    }
  })
  requestQueue = [] // clear queue
}

// response interceptor
service.interceptors.response.use(
  response => {
    lastRequest = {} // clear last request
    return response
  },
  async (error, request) => {
    if (error.response && error.response.status === 401) {
      if (!isPending) {
        isPending = true
        refreshToken().then(() => {
          isPending = false
          resendPendingRequests()
        })
      }

      return new Promise((resolve, reject) => {
        lastRequest.resolve = resolve
        lastRequest.reject = reject
        requestQueue.push({resolve, reject, config: error.config})
      })
      // await refreshToken()
    } else {
      // Message({
      //   message: error.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      return new Promise((resolve, reject) => {
        reject(error)
      })
      // return Promise.reject(error)
    }
  })

export default serviceDecorator



// WEBPACK FOOTER //
// ./src/utils/request.js